<template>
  <teleport to="body">
    <transition
      v-show="visible"
      name="fade"
    >
      <div
        class="back-top"
        :style="style"
        @click="handleClick"
      >
        <i class="back-top__icon"></i>
        <span>TOP</span>
      </div>
    </transition>
  </teleport>
</template>

<script lang="ts" setup>

import { computed, onMounted, onUnmounted, ref, toRefs } from 'vue';
import { throttle } from '@/utils';
import { scrollToTop } from '@/utils/scroll-to-top';


const props = withDefaults(defineProps<{
  visibilityHeight?: number // 滚动距离超过此值后才出现
}>(), { visibilityHeight: 400 });
const { visibilityHeight } = toRefs(props);

const visible = ref(false);

const throttledScrollHandler = throttle(() => {
  const scrollTop = document.documentElement.scrollTop ?? 0;
  visible.value = scrollTop >= visibilityHeight.value;
}, 300);

const bottomDis = 64;

const style = computed(() => ({
  bottom: `${bottomDis}px`
}));

onMounted(() => window.addEventListener('scroll', throttledScrollHandler));

onUnmounted(() => window.removeEventListener('scroll', throttledScrollHandler));

const handleClick = () => {
  scrollToTop();
};
</script>

<style lang="less" scoped>
@import "@/styles/var.less";

.back-top--position {
  position: fixed;
  right: 16px;
  width: 48px;
  height: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: @color-white;
  z-index: 100;

  &.fade-enter-active,
  &.fade-leave-active {
    transition: opacity 0.2s ease;
  }

  &.fade-enter-from,
  &.fade-leave-to {
    opacity: 0;
  }
}

.back-top {
  &:extend(.back-top--position);

  font-size: 12px;
  color: @color-text-primary;
  line-height: 12px;
  font-weight: 400;
  border: 1px solid rgba(@color-text-secondary, 20%);
  box-shadow: 0 4px 10px 0 rgba(@color-text-secondary, 20%);
  border-radius: 6px;
  transition: color 100ms;
  cursor: pointer;

  &:hover {
    color: @color-primary;

    .back-top__icon {
      background-color: transparent;
      background-image: url('@/assets/back-top/back-top-hover.svg');
      background-repeat: no-repeat;
      background-size: 100%;
    }
  }

  .back-top__icon {
    width: 13px;
    height: 13px;
    background-color: transparent;
    background-image: url('@/assets/back-top/back-top.svg');
    background-repeat: no-repeat;
    background-size: 100%;
  }
}
</style>
